import { useEffect, useState, useCallback } from "react";
import { Statistic, Spin, Tooltip } from "antd";
import { ExplorerClient } from "../proto/sgn/explorer/v1/ExplorerServiceClientPb";
import { GetTotalStatsRequest } from "../proto/sgn/explorer/v1/explorer_pb";
import { convertUSD } from "../utils/newFormat";
import "./dataOverview.less";
import tipIcon from "../images/toolTip.png";

interface IProps {
  reloadFlag: boolean;
}

const DataOverview = (props: IProps) => {
  const { reloadFlag } = props;
  const [totalStats, setTotalStats] = useState<{
    totalTxVolume: number;
    totalTxCount: number;
    last24TotalTxVolume: number;
    last24TotalTxCount: number;
    totalLiquidity: number;
    uniqueAddress: number;
  }>({
    totalTxVolume: 0,
    totalTxCount: 0,
    last24TotalTxVolume: 0,
    last24TotalTxCount: 0,
    totalLiquidity: 0,
    uniqueAddress: 0,
  });
  const [fetching, setFetching] = useState(false);
  const getData = useCallback(async () => {
    setFetching(true);
    const client = new ExplorerClient(
      `${process.env.REACT_APP_GRPC_SERVER_URL}`,
      null,
      null
    );
    const getTotalStatsRequest = new GetTotalStatsRequest();
    const res = await client.getTotalStats(getTotalStatsRequest, null);
    setFetching(false);
    const totalTxVolume = res.getTotalTransactionVolume();
    const totalTxCount = res.getTotalTransactionCount();
    const last24TotalTxVolume = res.getLast24TotalTransactionVolume();
    const last24TotalTxCount = res.getLast24TotalTransactionCount();
    const totalLiquidity = res.getTotalLiquidity();
    const uniqueAddress = res.getUniqueAddress();
    setTotalStats({
      totalTxVolume,
      totalTxCount,
      last24TotalTxVolume,
      last24TotalTxCount,
      totalLiquidity,
      uniqueAddress,
    });
  }, []);
  useEffect(() => {
    getData();
  }, [getData, reloadFlag]);

  const {
    totalTxVolume,
    totalTxCount,
    last24TotalTxVolume,
    last24TotalTxCount,
    totalLiquidity,
    uniqueAddress,
  } = totalStats;

  const last24HourTransactionVolumeTips = () => {
    return (
      <div style={{ display: "flex", alignItems: "center" }}>
        Last 24 hour transaction volume
        <Tooltip
          placement="top"
          title={
            <div className="toolsDetail">
              The transaction volume includes
              <div>
                (1) the transfers under the pool-based bridge model (xLiquidity)
              </div>
              <div>
                (2) the transfers under the canonical mapping bridge model
                (xAsset)
              </div>
              <div>
                (3) LP aggregate&remove liquidity (which involves internal
                liquidity transfers)
              </div>
              <br />
              <a
                href="https://cbridge-docs.celer.network/introduction/fungible-token-bridging-models"
                target="_blank"
                rel="noreferrer"
                className="linkTitle"
              >
                {"Learn More "}
              </a>
              about these models.
            </div>
          }
          color="#FFFFFF"
          overlayInnerStyle={{
            color: "#0A1E42",
            width: 250,
            fontFamily: "SF Pro Text",
            fontSize: 12,
            lineHeight: "14px",
          }}
        >
          <img src={tipIcon} className="withTooltip" alt="tooltip icon" />
        </Tooltip>
      </div>
    );
  };

  const totalValueLockedTips = () => {
    return (
      <div style={{ display: "flex", alignItems: "center" }}>
        Total Value Locked
        <Tooltip
          placement="top"
          title={
            <div className="toolsDetail">
              The TVL includes the funds locked in the bridge contract
              (pool-based bridge) and the the funds locked in the tokenVault
              contract (canonical token bridge). See
              <br />
              <a
                href="https://cbridge-docs.celer.network/reference/contract-addresses"
                target="_blank"
                rel="noreferrer"
                className="linkTitle"
              >
                {"contract addresses."}
              </a>
            </div>
          }
          color="#FFFFFF"
          overlayInnerStyle={{
            color: "#0A1E42",
            width: 250,
            fontFamily: "SF Pro Text",
            fontSize: 12,
            lineHeight: "14px",
          }}
        >
          <img src={tipIcon} className="withTooltip" alt="tooltip icon" />
        </Tooltip>
      </div>
    );
  };

  return (
    <Spin spinning={fetching}>
      <div className="stats-content-dataview">
        <div className="dataview-item">
          <Statistic
            title="Total transaction volume"
            value={convertUSD(totalTxVolume, "round", 0)}
          />
        </div>
        <div className="dataview-item">
          <Statistic
            title={last24HourTransactionVolumeTips()}
            value={convertUSD(last24TotalTxVolume, "round", 0)}
          />
        </div>
        <div className="dataview-item">
          <Statistic
            title={totalValueLockedTips()}
            value={convertUSD(totalLiquidity, "round", 0)}
          />
        </div>
        <div className="dataview-item">
          <Statistic title="Total transaction count" value={totalTxCount} />
        </div>
        <div className="dataview-item">
          <Statistic
            title="Last 24 hour transaction count"
            value={last24TotalTxCount}
          />
        </div>
        <div className="dataview-item">
          <Statistic title="Unique Addresses" value={uniqueAddress} />
        </div>
      </div>
    </Spin>
  );
};

export default DataOverview;
